import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { inject, computed, useCssModule } from 'vue';
import { UiIcon } from '@huntflow/ui';
import { removeLayerSymbol } from '@/shared/legacy/ui/base-layer/constants';
import BaseRow from './row.vue';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'LayoutHeader'
},
  __name: 'header',
  props: {
    title: { default: '' },
    allowClose: { type: [Boolean, String], default: 'layer' },
    borderAfter: { type: Boolean, default: true }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {





const emit = __emit;

const removeLayer: any = inject(removeLayerSymbol);

const shouldShowCloseButton = computed(() => __props.allowClose === 'event-only' || (__props.allowClose === 'layer' && removeLayer));

const handleClose = () => {
  emit('close');
  if (__props.allowClose !== 'event-only' && removeLayer) {
    removeLayer();
  }
};

const styles = useCssModule();

const contentStyles = computed(() => ({
  [styles.content]: true,
  [styles.borderAfter]: __props.borderAfter
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseRow, {
    class: _normalizeClass(_ctx.$style.row)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(contentStyles.value)
      }, [
        _renderSlot(_ctx.$slots, "default", {
          titleClass: _ctx.$style.primaryTitle,
          title: __props.title
        }, () => [
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.$style.primaryTitle),
            "data-qa": "primary-title"
          }, _toDisplayString(__props.title), 3)
        ]),
        (shouldShowCloseButton.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              "data-qa": "close",
              class: _normalizeClass(_ctx.$style.closeButton),
              onClick: handleClose
            }, [
              _createVNode(_unref(UiIcon), { name: "close-28" })
            ], 2))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})